export default {
  GET_PRODUCT_BY_SKUS: 'GET_PRODUCT_BY_SKUS',
  GET_PRODUCT_BY_IDS: 'GET_PRODUCT_BY_IDS',
  CLEAR: 'CLEAR',
  SET_PRODUCT_VIEWED: 'SET_PRODUCT_VIEWED',
  CLEAR_MAP_PRODUCT: 'CLEAR_MAP_PRODUCT',
  SET_HISTORY_TODAY: 'SET_HISTORY_TODAY',
};
